// React Dependencies
import React from 'react';

// External Dependencies
import { makeStyles } from '@material-ui/core/styles';
import { Avatar, Button } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';

// Internal Dependencies
import { IsEmpty } from '../../../common/checks';
import { Trim, getThumbnailFromVideoURL } from '../../../common/util';
import Constants, { Colours } from '../../../common/constants';

const useStyles = makeStyles(() => ({
  root: {
    display:      'flex',
    marginBottom: 10,
  },
  details: {
    display:       'flex',
    flexDirection: 'row',
    position:      'relative',
    padding:       0,
  },
  content: {
    display:       'flex',
    flexDirection: 'column',
    flex:          '1 0',
    paddingTop:    10,
    paddingRight:  0,
    paddingLeft:   10,
    paddingBottom: 10,
  },
  cover: {
    width:   100,
    height:  100,
    display: 'flex',
  },
  twoLine:    { display: 'block', height: 20, overflow: 'hidden' },
  floatRight: { marginLeft: 'auto' },
  ribbon:     {
    position:      'absolute',
    color:         'white',
    width:         150,
    zIndex:        3,
    textAlign:     'center',
    textTransform: 'uppercase',
    padding:       5,
    font:          'Lato',
    '&::before':   {
      position: 'absolute',
      zIndex:   -1,
      content:  '',
      display:  'block',
      border:   '5px solid #2980b9',
    },
    '&::after': {
      position: 'absolute',
      zIndex:   -1,
      content:  '',
      display:  'block',
      border:   '5px solid #2980b9',
    },
    transform:  'rotate(-45deg)',
    top:        20,
    marginLeft: -45,
  },
  category: {
    borderRadius:    2,
    color:           'white',
    fontSize:        '85%',
    overflow:        'hidden',
    padding:         3,
    paddingLeft:     6,
    textOverflow:    'ellipsis',
    whiteSpace:      'nowrap',
    boxSizing:       'border-box',
    backgroundColor: Colours.Grey,
  },
}));

export default function SearchCard({ data, onAdd, lastIndex }) {
  const classes = useStyles();

  const pin = (payloadData) => {
    const { postId, position } = payloadData;
    const payload = {
      postId,
      position,
      positionType: Constants.PositionType.Rotatable,
    };

    onAdd(payload);
  };

  return data.map((v) => {
    const isVideo = !!(!IsEmpty(v.videos) && v.videos.length > 0);
    const media = isVideo
      ? (
        <img
          src={getThumbnailFromVideoURL(v.videos[0])}
          className={classes.cover}
          alt=""
        />
      )
      : (v.images && v.images.length > 0 && v.images[0].display) ? <CardMedia className={classes.cover} image={v.images[0].display} /> : '';

    return (
      <div className="col-md-4">
        <Card key={`searchCard-${v.id}`} className={classes.root}>
          <div className={classes.details}>
            {media}
            <CardContent style={{ paddingBottom: 10 }} className={classes.content}>
              <Typography variant="subtitle1" color="textSecondary">
                <a target="_blank" rel="noreferrer" href={`/admin/page/${v.pageId}/post/${v.id}`}>
                  {
                    !IsEmpty(Trim(v.title)) ? ((v.title.length >= 50) ? `${v.title.substring(0, 50)}...` : v.title)
                      : '--'
                  }
                </a>
              </Typography>
              <Typography>
                {
                  IsEmpty(v.promoFromDate)
                    ? `${v.promoType} period unspecified`
                    : `${new Date(v.promoFromDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })} to ${new Date(v.promoTillDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}`
                }
              </Typography>

              <p className="mb-3 mt-1">
                <a target="_blank" rel="noreferrer" href={`/admin/page/${v.pageId}`} className={classes.details} style={{ alignItems: 'center', fontSize: 12, color: Constants.Colours.Background }}>
                  <Avatar src={v.logo} sizes="small" />
                  <div style={{ marginLeft: 10 }}>{v.brand}</div>
                </a>
              </p>

            </CardContent>
          </div>
          <Button
            disabled={v.isPinned}
            onClick={() => pin({ postId: v.id, position: lastIndex + 1 })}
            style={{ marginLeft: 'auto' }}
            color="secondary"
          >
            {v.isPinned ? 'Pinned' : 'Pin'}
          </Button>
        </Card>
      </div>
    );
  });
}
